// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { jettingAppJettingStyles } from "@stoneage/App/Components/JettingAppComponents/JettingAppJetting";
import IconTooltip from "@stoneage/XDL/Icons/IconTooltip";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

jettingAppJettingStyles.wrapper = {
    css: css`
        overflow-x: auto;
    `,
};

jettingAppJettingStyles.header = {
    css: css`
        display: grid;
        grid-column-gap: 12px;
        grid-template-columns: minmax(40px, 60px) minmax(40px, 60px) minmax(60px, 1fr) minmax(106px, 1fr) minmax(
                45px,
                60px
            );

        font-size: 14px;
        line-height: 22px;
        font-weight: bold;
        padding-bottom: 8px;
        border-bottom: 1px solid ${color("common.ui5")};

        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(124px, 1fr) minmax(124px, 1fr) minmax(255px, 1fr) minmax(149px, 1fr);
        }
        ${xScreen("lte", "xs")} {
            grid-template-columns: minmax(50px, auto) minmax(50px, auto) minmax(106px, 1fr) minmax(60px, auto);
        }
    `,
};

jettingAppJettingStyles.angle = {
    css: css`
        grid-column: 1 / 2;
    `,
};

jettingAppJettingStyles.jets = {
    css: css`
        grid-column: 2/3;
        @media print {
            display: none;
        }
    `,
};
jettingAppJettingStyles.qty = {
    css: css`
        grid-column: 3 / 4;
        ${xScreen("lte", "md")} {
            grid-column: 2/3;
        }
    `,
};
jettingAppJettingStyles.size = {
    css: css`
        grid-column: 4 / 5;
        display: flex;
        align-items: center;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 4;
        }
    `,
};
jettingAppJettingStyles.tooltip = {
    iconProps: {
        src: IconTooltip,
        color: "primary.main",
        size: 14,
        css: css`
            margin-left: 4px;
            &: hover {
                opacity: 0.33;
            }
        `,
    },
    cssOverrides: {
        tooltipClickable: css`
            display: flex;
            &[aria-expanded="true"] {
                ${IconWrapper} {
                    color: ${color("common.black")};
                }
            }
        `,
    },
};
jettingAppJettingStyles.flow = {
    css: css`
        grid-column: 5 / 6;
        ${xScreen("lte", "md")} {
            grid-column: 4 / 5;
        }
    `,
};
jettingAppJettingStyles.rowWrapper = {
    css: css`
        padding-block: 8px;
        border-bottom: 1px solid ${color("common.ui5")};
    `,
};
